import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { SERVICES } from '../calculatorConstants';
import styles from '../Calculator.module.css';

interface StepServicesProps {
    selectedServices: string[];
    onToggle: (service: string) => void;
}

const StepServices: React.FC<StepServicesProps> = ({ selectedServices, onToggle }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.step}>
            <div className={styles.header}>
                <h3 className={styles.title}>{t('calculator.services.title')}</h3>
                <p className={styles.subtitle}>{t('calculator.services.subtitle')}</p>
            </div>
            <div className={styles.technologiesContainer}>
                {SERVICES.map((service, index) => (
                    <label
                        key={service}
                        className={`${styles.option} ${styles.technologyOption} ${
                            selectedServices.includes(service) ? styles.selected : ''
                        }`}
                    >
                        <input
                            type="checkbox"
                            checked={selectedServices.includes(service)}
                            onChange={() => onToggle(service)}
                            className={styles.checkbox}
                        />
                        <span className={styles.checkmark}></span>
                        {t(`calculator.services.${index + 1}`)}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default StepServices;
